import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { Table, message, Icon, Button, Spin } from 'antd';
import request from 'request'
import Loading from 'ui-loading';
import Err from 'ui-error';
import styles from './style.scss?__local';

const defaultPageSize = process.env.HUYA_APP_ENV === 'production' ? 10 : 2 // 测环境数据太少了，为了弄出分页

function DailyFeeList({extUuid, serviceFeeType}) {
  const [pageNum, setPageNum] = useState(1)
  const res = useRemoteData(pageNum, extUuid)

  const col = {
    date: 'date',
    dailyUse: 'dailyUse',
    totalUse: 'totalUse',
    addUpExpense: 'addUpExpense',
  }

  const columns = [
    {
      title: '日期',
      dataIndex: col.date,
    },
    {
      title: '当日使用计数',
      dataIndex: col.dailyUse,
    },
    {
      title: '本月累计数',
      dataIndex: col.totalUse,
    },
    {
      title: '本月累计费用',
      dataIndex: col.addUpExpense,
    },
  ]

  let dataSource = []

  if (res && res.data) {
    dataSource = makeDataSource(col, res.data.serviceFeeList || [], serviceFeeType)
  }

  let pagination = false

  if (res && res.data && res.data.total > defaultPageSize) {
    pagination = {
      onChange: pageNum => setPageNum(pageNum),
      total: res.data.total,
      defaultPageSize,
      pageSize: defaultPageSize,
      current: pageNum,
    }
  }

  let loading = false

  if (res == null) {
    loading = true
  } else if (res.data) {
    loading = false
  } else {
    loading = {
      indicator: <Err err={`获取数据失败：${res.err}`} />,
    }
  }

  return (
    <div style={{background: '#fafafa'}}>
      <Table {...{ columns, dataSource, pagination, loading, size: 'small'}} />
    </div>
  )
}

function useRemoteData(page, extUuid) {
  let [res, setRes] = useState(null)

  useEffect(() => {
    setRes(null)

    request({
      url: request.api.anchorExpenseDetail,
      type: 'GET',
      data: {
        extUuid,
        page,
        pageSize: defaultPageSize,
      },
    })
      .done(data => setRes({data}))
      .fail(err => setRes({err}))

    return () => {
      setRes = () => {}
    }
  }, [page, extUuid])

  return res
}

function makeDataSource(col, serviceFeeList, sft) {
  // 如果计费类型是使用时长 需要把秒转换成分钟
  const isUseTimeType = sft.type == 1;

  return serviceFeeList.map((item, index) => ({
    key: index,
    [col.date]: item.date,
    [col.dailyUse]: `${isUseTimeType ? parseInt(item.dailyUse / 60) : item.dailyUse} ${sft.unit}`,
    [col.totalUse]: `${isUseTimeType ? parseInt(item.totalUse / 60) : item.totalUse} ${sft.unit}`,
    [col.addUpExpense]: `${item.addUpExpense <= sft.maxServiceFee ? item.addUpExpense : sft.maxServiceFee} 虎牙币`,
  }))
}

export default DailyFeeList;
